import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { XCircle } from 'lucide-react';

const PaymentCancel = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-xl shadow-lg p-8 max-w-md w-full text-center">
        <div className="w-20 h-20 bg-slate-100 rounded-full flex items-center justify-center mx-auto mb-4">
          <XCircle className="w-12 h-12 text-slate-400" />
        </div>
        <h1 className="text-2xl font-bold text-slate-900 mb-2">Paiement annulé</h1>
        <p className="text-slate-500 mb-6">
          Vous avez annulé le processus de paiement. Aucun montant n'a été prélevé.
        </p>
        <div className="space-y-3">
          <Button 
            onClick={() => navigate('/')} 
            className="w-full bg-slate-900 text-white"
          >
            Retour au tableau de bord
          </Button>
          <Button 
            onClick={() => navigate(-1)} 
            variant="outline"
            className="w-full"
          >
            Réessayer
          </Button>
        </div>
      </div>
    </div>
  );
};

export default PaymentCancel;
